import { SkeletonBox as SkeletonBoxComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const BankConnectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
`

export const InnerContainer = styled.div``

export const SkeletonBox = styled(SkeletonBoxComponent)`
  margin: auto;
`
